module.exports = __webpack_public_path__ + "img/icon-microsoft.c6967e9c.svg";